export const HOME = '/'
export const ABOUT_US = '/#o-nas'
